export default {
  howItWorks: {
    en: "How it works",
    ja: "使い方"
  }
}
